import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import './index.css';
import Login from "./components/Login";
import {createBrowserRouter, Navigate, RouterProvider} from "react-router-dom";
import ProtectedRoutes from "./components/ProtectedRoutes";
import {AuthProvider} from "./contexts/AuthContext";
import MainTable from "./components/MainTable";
import {AppProvider} from "./contexts/AppContext";
import {initAnalyticsListener} from "./utils/Analytics";
import DocumentFullPage from "./components/DocumentFullPage";
import {ThemeProvider} from "./contexts/ThemeContext";
import SessionExpiry from "./components/ux_ui/SessionExpiry";
import {SessionExpiredProvider} from "./contexts/SessionExpiredContext";
import FAQ from "./components/FAQ";
import Onboarding from "./components/Onboarding";
import AccessRequestsTable from "./components/AccessRequestsTable";
import TgConnect from "./components/TgConnect";

initAnalyticsListener();


const routes = [
    {
        path: '/',
        element: <Login/>
    },
    {
        path: '/dashboard',
        element: <ProtectedRoutes/>,
        children: [
            {
                path: 'all-documents',
                element: <MainTable/>,
            },
            {
                path: 'i-manage-responsible',
                element: <MainTable/>,
            },
            {
                path: 'i-manage-assigned',
                element: <MainTable/>,
            },
            {
                path: 'i-manage-assigned-others',
                element: <MainTable/>,
            },
            {
                path: 'role-owner',
                element: <MainTable/>,
            },
            {
                path: 'role-responsible',
                element: <MainTable/>,
            },
            {
                path: 'role-editor',
                element: <MainTable/>,
            },
            {
                path: 'role-viewer',
                element: <MainTable/>,
            },
            {
                path: 'archive',
                element: <MainTable/>,
            },
            {
                path: 'access-requests-to-me',
                element: <AccessRequestsTable/>,
            },
            {
                path: 'access-requests-from-me',
                element: <AccessRequestsTable/>,
            },
            {
                path: 'faq',
                element: <FAQ/>,
            },
            {
                path: 'onboarding',
                element: <Onboarding/>,
            },
            {
                path: 'document/:documentId',
                element: <DocumentFullPage/>,
            },
            {
                path: 'tg/registration',
                element: <TgConnect/>,
            },
        ],
    },
    {
        path: '*',
        element: <Navigate to="/" replace/>,
    }
];

const router = createBrowserRouter(routes);
const root = ReactDOM.createRoot(document.getElementById('root'));

if (process.env.NODE_ENV === 'development') {
    const suppressedWarnings = ['findDOMNode is deprecated'];
    const originalConsoleError = console.error;
    console.error = (...args) => {
        if (typeof args[0] === 'string' && suppressedWarnings.some(w => args[0].includes(w))) {
            return;
        }
        originalConsoleError(...args);
    };
}


root.render(
    <AuthProvider>
        <AppProvider>
            <SessionExpiredProvider>
                <ThemeProvider>
                    <RouterProvider router={router}/>
                    <SessionExpiry/>
                </ThemeProvider>
            </SessionExpiredProvider>
        </AppProvider>
    </AuthProvider>
);

